export function getFacetOrderInitialState() {
    return [];
}
